import React, {FC, HTMLAttributes} from "react"
import styled from "styled-components"

const StyledItem = styled.div`
    max-width: 100%;
    width: 1280px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 15px
`

const Item: FC<HTMLAttributes<HTMLDivElement>> = (props) => <StyledItem {...props} />

export default Item